// The API may return records in different casings (PascalCase vs camelCase)
// depending on the backend version — normalize to lowercase keys here so the
// UI components only ever deal with one shape.
const firstDefined = (...vals) => vals.find(v => v !== undefined && v !== null)

export const normalizeVideo = (raw = {}) => ({
    id: firstDefined(raw.id, raw._id, raw.Id, raw.pbEducationalId, ''),
    title: String(firstDefined(raw.title, raw.Title, '')).trim(),
    url: firstDefined(raw.url, raw.Url, ''),
    duration: firstDefined(raw.duration, raw.Duration, 0),
    category: firstDefined(raw.category, raw.Category, []),
    tags: firstDefined(raw.tags, raw.Tags, []),
    product: firstDefined(raw.product, raw.Product, ''),
    uploadDate: firstDefined(raw.uploadDate, raw.UploadDate, ''),
    description: firstDefined(raw.description, raw.Description, ''),
    steps: firstDefined(raw.steps, raw.Steps, raw.step, raw.Step, 0),
    thumbnail: firstDefined(raw.thumbnail, raw.Thumbnail, undefined),
})

const normalizeItems = (items) => Array.isArray(items) ? items.map(normalizeVideo) : []

const getVideos = async (filters) => {
    const awsGateway = process.env.REACT_APP_AWS_GATEWAY === undefined
        ? process.env.AWS_GATEWAY
        : process.env.REACT_APP_AWS_GATEWAY
    let response = {
        ok:false,
        message:'',
        data:null
    }
    try{
        function concatUrl(url, params){
            const u = new URL(url);
            Object.entries(params).forEach(([k, v]) => {
                const val = typeof v === 'string' ? v.trim() : v;
                if (val !== undefined && val !== null && val !== '') {
                    u.searchParams.set(k, val);
                }
            });
            return u;
        }
        let {orderByAsc, searchText, filterBy, indexPage, product} = filters
        const url = awsGateway + '/media/video'

        const vals = {
            search: (searchText || '').trim(),
            page: indexPage,
            sortdirection: orderByAsc ? 'asc' : 'desc',
            sortby: filterBy
        }
        if (product) vals.product = product;
        let header  = new Headers()
        header.append('Content-Type','application/json')
        const urlRequest = concatUrl(url,vals)
        const requestOptions = {
            method:'GET',
            headers:header
        }
        if (filters.signal) requestOptions.signal = filters.signal
        await fetch(urlRequest.href, requestOptions).then(async (res) => {

           response.ok = res.ok
           const payload = await res.json()
           response.data = payload && Array.isArray(payload.items)
               ? { ...payload, items: normalizeItems(payload.items) }
               : payload


        }).catch(error =>{

            response.message = error
        })
    }
    catch(error){

        response.message = error
    }
     return await response;

}
export default getVideos